import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import React from 'react'
import { textStyleKeys } from '~/themes/textStyles'

interface ReportingModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  content: React.ReactNode
}

export const ReportingModal: React.FC<ReportingModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent w="80vw" h="80vh" maxW="80vw" maxH="80vh">
        <ModalHeader>
          <Flex
            textAlign="center"
            textStyle={textStyleKeys.Body1_Bold}
            color="gray.1300"
          >
            {title}
          </Flex>
        </ModalHeader>
        <ModalCloseButton borderRadius="full" />
        <ModalBody>{content}</ModalBody>
      </ModalContent>
    </Modal>
  )
}
